var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartControlReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "RB5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RB5",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-7",
    fill: "#187ABA",
    cx: 10,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "streamline-icon-rotate-forward@48x48-copy-2",
    transform: "translate(10.000000, 4.000000)",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "0 5 2 2.5 0 0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.0728404,15.2967309 C12.5581217,15.2967309 14.5728404,13.2820123 14.5728404,10.7967309 C14.5728404,9.38472888 13.9225101,8.12461959 12.9050348,7.29958817 C12.1316399,6.67247212 11.1461197,6.29673094 10.0728404,6.29673094 C7.58755898,6.29673094 5.57284036,8.31144956 5.57284036,10.7967309",
    id: "Oval-Copy-8",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    transform: "translate(10.072840, 10.796731) rotate(186.000000) translate(-10.072840, -10.796731) "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartControlReset);
export default __webpack_public_path__ + "static/media/chartControl_Reset.21b7bbf0629544b881fdabed1d4e64e3.svg";
export { ForwardRef as ReactComponent };